import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Badge,
  Button,
  Icon,
  InputAdornment,
  FormHelperText,
  MenuItem,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from '@material-ui/core';
import ViewColumn from 'helpers/ViewColumn';
import { downloadCustomerSubscriptionsApi } from 'api';
import { useStyles } from './styles';


const CustomTableToolbar = (
  {
    onSearch,
    setOpenFilter,
    filterConditions,
    tableCells,
    setHeadTableCells
  }: ICustomToolbar
) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState('');
  const [searchField, setSearchField] = useState('increment_id');
  const selectedConditions = Object.values(filterConditions).filter((condition) => !!condition?.value.length);
  const { customerSubscriptionsList } = useSelector((state: IReduxState) => state.customer_subscriptions);

  return (
    <Toolbar className="w-full relative">
      <div className="flex-column w-full">
        <div className="flex items-center justify-between w-full">
          <div className="w-full flex items-center">
            <TextField
              variant="outlined"
              className={`w-full max-w-300 text-primary ${classes.bgBlue} ${classes.customSearch}`}
              name="search-orders-value"
              placeholder="Search"
              value={searchValue}
              onChange={(event) => setSearchValue(event.target.value)}
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  event.preventDefault();
                  onSearch(searchValue, searchField);
                }
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {!searchValue.length ?
                      <Icon color="primary">search</Icon>
                      :
                      <Icon
                        color="primary"
                        className="cursor-pointer"
                        onClick={() => {
                          setSearchValue(() => '');
                          onSearch('', 'name');
                        }}
                      >
                        close
                      </Icon>
                    }
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              select
              variant="outlined"
              className={`w-full max-w-200 mr-3 text-primary ${classes.bgBlue} ${classes.customSearchField}`}
              name="search-orders-field"
              value={searchField}
              onChange={(event) => {
                setSearchField(event.target.value);

                if (searchValue) {
                  onSearch(searchValue, event.target.value);
                }
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">by</InputAdornment>
                )
              }}
            >
              <MenuItem value="increment_id">Subscription ID</MenuItem>
              <MenuItem value="description">Description</MenuItem>
              <MenuItem value="customer_firstname">First Name</MenuItem>
              <MenuItem value="customer_lastname">Last Name</MenuItem>
            </TextField>
            <Button
              color="primary"
              variant="contained"
              className="mr-2 px-3 min-w-120 min-h-40"
              onClick={() => onSearch(searchValue, searchField)}
            >
              <Icon className="mr-2">search</Icon>
              <span className="uppercase">Search</span>
            </Button>
            <Badge
              badgeContent={selectedConditions.length}
              color="primary"
              overlap="rectangular"
            >
              <Tooltip title="Filter by">
                <Button
                  variant="outlined"
                  color="primary"
                  className={classes.filterBtn}
                  onClick={() => setOpenFilter(true)}
                >
                  <Icon className="text-primary mr-2">
                    filter_list
                  </Icon>
                  <span className="text-brand">Filter By</span>
                </Button>
              </Tooltip>
            </Badge>
            <Tooltip title="Download">
              <Button
                variant="outlined"
                color="primary"
                disabled={!customerSubscriptionsList.length}
                className={classes.filterBtn}
                onClick={() => downloadCustomerSubscriptionsApi({dispatch})}
              >
                <Icon className={`${!!customerSubscriptionsList.length ? 'text-primary' : null} mr-2`}>
                  cloud_download
                </Icon>
                <span className={`${!!customerSubscriptionsList.length ? 'text-brand' : ''}`}>
                  Download
                </span>
              </Button>
            </Tooltip>
          </div>
          <div className="flex items-center justify-end">
            <ViewColumn storageKey="SubscriptionsTableCells" tableCells={tableCells} setHeadTableCells={setHeadTableCells} />
          </div>
        </div>
        {!!searchValue.length &&
        <FormHelperText className={classes.helperText}>
          <Typography variant="caption">
            Press &apos;Enter&apos; to search
          </Typography>
        </FormHelperText>
        }
      </div>
    </Toolbar>
  );
};

export default CustomTableToolbar;
